import { Component, inject, OnInit,  } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { on } from 'events';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { Globals } from 'src/app/globals';
import { InjuryPreviewinfoComponent } from 'src/app/injury/screens/injury-previewinfo/injury-previewinfo.component';
import { TestProfile, TestProfileViewModel } from 'src/app/shared/models/test.model';
import { TestService } from 'src/app/shared/test.service';
import { MatCard, MatCardHeader, MatCardModule } from "@angular/material/card";
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { EditLimitDialogComponent } from '../../components/edit-limit-dialog/edit-limit-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { A11yModule } from "@angular/cdk/a11y";
import { AddTestToProfileDialogComponent } from '../../add-test-to-profile-dialog/add-test-to-profile-dialog.component';
import { ConfirmationDialogComponent } from 'src/app/shared/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-profile-limits',
  imports: [AsyncPipe, MatCardModule, MatCardHeader, MatButtonModule, MatDividerModule, MatIconModule, A11yModule],
  templateUrl: './profile-limits.component.html',
  styleUrl: './profile-limits.component.css'
})
export class ProfileLimitsComponent implements OnInit {

  private _globals = inject(Globals);
  private activatedRoute = inject(ActivatedRoute);
  private testService = inject(TestService);
  private dialog = inject(MatDialog);  
  profile$: Observable<any>;
  ProfileId: string;

  ngOnInit() {
    this._globals.titleBarText = "Profile";

    this.activatedRoute.params.subscribe(params => {
      this.ProfileId = params['ProfileId'];
      this.profile$ = this.testService.getProfile(this.ProfileId);
    });

      
  }

  findLimit(testLimits: any[], testId: number) {
    let tl = testLimits.find(t => t.TestId === testId);
    return tl ? tl : null;
  }

  editTestLimits(Test: TestProfileViewModel, Limit: any, ProfileId: number, ProfileName: string) {
    const dialogRef = this.dialog.open(EditLimitDialogComponent, {
      data: {
        Test: Test,
        Limit: Limit,
        ProfileId: ProfileId,
        ProfileName: ProfileName
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.ngOnInit();
      }
    });

  }

  showLimitGuide() {

  }




  removeTest(TestId: string) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: "Do you want to remove the test and the related test limits from the profile? "
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(result);
        this.testService.removeTestFromProfile(TestId, this.ProfileId).subscribe(result => {
          this.ngOnInit();
        });
        //Notify about delete

      }
    });

  }

  addTestOpenDialog() {
    const dialogRef = this.dialog.open(AddTestToProfileDialogComponent, {
      width: '350px',
      data: { ProfileId: this.ProfileId }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        //console.log(result);

        this.testService.addTestToProfile(this.ProfileId, result).subscribe(ret => {

          this.ngOnInit();

        });
      }

    });
  }

}
